<template>
  <div
    id="dropdown-container"
    :class="{ disabled: disabled }"
    :style="{
      width: width || '240px',
    }"
  >
    <a
      class="select-text input"
      :class="{ error: error, disabled: disabled }"
      @click.stop.passive="toggleSelect"
      v-click-outside="setClose"
      :tabindex="disabled ? '-1' : '0'"
    >
      <span class="select-text-selected-value">{{ selected.value }}</span>
      <span class="af af-chevron-down select-arrow"></span>
    </a>
    <transition name="fade">
      <div class="select-list" v-if="dropdownActive">
        <!-- @slot items -->
        <slot>
          <div class="select-item" v-for="(option, index) of options" :key="index" @click.stop.passive="onChange($event, option)">
            {{ option.value }}
          </div>
        </slot>
      </div>
    </transition>
  </div>
</template>

<script>
import ClickOutside from '../utils/ClickOutside';

export default {
  name: 'Dropdown',
  props: {
    /**
     * @model
     * Selected value
     */
    modelValue: [String, Number],
    /**
     * List of options or items
     */
    options: Array,
    /**
     * Width of the dropdown
     */
    width: {
      type: String,
      default: '240 px',
    },
    /**
     * To disable dropdown
     */
    disabled: Boolean,
    error: Boolean,
  },
  data: function () {
    return {
      dropdownActive: false,
    };
  },
  methods: {
    setClose() {
      this.dropdownActive = false;
    },
    onChange(event, value) {
      this.setClose();
      /**
       * Update the selected value
       * @property {number} id id of the selected value
       */
      this.$emit('update:modelValue', value.id);
    },
    toggleSelect() {
      if (this.disabled) {
        this.dropdownActive = false;
      } else {
        this.dropdownActive = !this.dropdownActive;
      }
    },
  },
  computed: {
    selected() {
      let d = {
        id: -1,
        value: 'Select',
      };

      if (!this.options || !this.options.length) {
        return d;
      }

      return this.options.filter((option) => option.id == this.modelValue)[0] || d;
    },
  },

  directives: {
    ClickOutside,
  },
};
</script>

<style lang="postcss">
.fade-enter-active {
  transition: opacity ease-out 100ms;
}
.fade-leave-active {
  transition: opacity ease-in 100ms;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

#dropdown-container {
  position: relative;
  cursor: pointer;

  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

  .select-text,
  .select-list {
    box-sizing: border-box;
    width: 100%;
  }

  .select-text {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .select-arrow {
      transition: transform ease-out 200ms;
    }

    .select-text-selected-value {
      white-space: nowrap;
      overflow: hidden;
    }

    .select-text-selected-value:after {
      position: absolute;
      right: 24px;
      height: 24px;
      width: 32px;
      content: '';
      background: linear-gradient(to right, rgba(255, 255, 255, 0) 30%, rgba(255, 255, 255, 1) 70%);
      pointer-events: none;
    }
  }

  .select-list {
    top: 42px;
    position: absolute;
    z-index: 3;
    box-shadow: 0 var(--box-shadow-blur) var(--box-shadow-spread) var(--shadow-color);

    .select-item {
      background: white;
      padding: var(--space-2) var(--space-3);
      display: flex;
      align-items: center;

      transition: background-color 200ms ease-out, color 200ms ease-out;

      /* purgecss ignore */
      &:hover {
        background: var(--grey-ultra-light);
      }
    }
  }

  &.disabled {
    .select-text {
      cursor: default;
    }
  }
}
</style>
